import React from 'react';
import ReactPaginate from 'react-paginate';
import { Inbox } from 'lucide-react';
import '../../styles/components/admin/AdminTable.css';

const AdminTable = ({ 
  columns, 
  data, 
  loading = false,
  pagination = null,
  onPageChange,
  actions = null 
}) => {
  if (loading) {
    return (
      <div className="admin-table-loading">
        <div className="spinner"></div>
        <p>Carregando dados...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="admin-table-empty">
        <Inbox size={48} className="empty-icon" />
        <p>Nenhum dado encontrado</p>
      </div>
    );
  }

  return (
    <div className="admin-table-container">
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th 
                  key={column.key}
                  style={{ width: column.width }}
                  className={column.align ? `text-${column.align}` : ''}
                >
                  {column.label}
                </th>
              ))}
              {actions && <th className="text-center">Ações</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={row.id || rowIndex}>
                {columns.map((column) => (
                  <td 
                    key={`${row.id || rowIndex}-${column.key}`}
                    className={column.align ? `text-${column.align}` : ''}
                  >
                    {column.render 
                      ? column.render(row[column.key], row) 
                      : row[column.key]
                    }
                  </td>
                ))}
                {actions && (
                  <td className="text-center">
                    <div className="table-actions">
                      {actions(row)}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {pagination && pagination.totalPages > 1 && (
        <div className="admin-table-pagination">
          <div className="pagination-info">
            Mostrando página {pagination.page} de {pagination.totalPages} ({pagination.total} registros)
          </div>
          <ReactPaginate
            previousLabel="← Anterior"
            nextLabel="Próximo →"
            pageCount={pagination.totalPages}
            onPageChange={({ selected }) => onPageChange && onPageChange(selected + 1)}
            initialPage={pagination.page - 1}
            containerClassName="pagination"
            activeClassName="active"
            disabledClassName="disabled"
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
          />
        </div>
      )}
    </div>
  );
};

export default AdminTable;
